import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode } from "vue"

import { useRoute } from "vue-router";
import { useUserStore } from "@/stores/user";
import { reportingPages } from "@/common/reportingPages";
import { getKey } from "@/common/util";
import TileCard from "@/components/util/TileCard.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportingView',
  setup(__props) {

const router = useRoute();
const userStore = useUserStore();


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("nav", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(reportingPages).find(a => a.role === _unref(userStore).getUserRole)?.pages, (item, index) => {
        return (_openBlock(), _createBlock(_component_router_link, {
          key: _unref(getKey)('nav', index),
          to: item.to,
          class: _normalizeClass({ active: item.isActive(_unref(router)) })
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.text), 1)
          ]),
          _: 2
        }, 1032, ["to", "class"]))
      }), 128))
    ]),
    _createVNode(TileCard, { class: "view-body" }, {
      body: _withCtx(() => [
        _createVNode(_component_router_view)
      ]),
      _: 1
    })
  ], 64))
}
}

})